import PropTypes from "prop-types";
import classnames from "classnames";

import "./pill.scss";

const Pill = ({ text, type, className }) => {
  if (!["ready", "pending", "danger", "draft"].includes(type)) type = "draft";
  return (
    <span
      className={classnames("pill", className, { [`pill--${type}`]: type })}
    >
      {text}
    </span>
  );
};

Pill.propTypes = {
  text: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
};

Pill.defaultProps = {
  type: "draft",
};

export default Pill;
